export default __webpack_public_path__ + "static/media/foto.a8371cc0.jpg";